import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { AuthenticationService } from '@app/core/services/authentication.service';
import { UserStorageService } from '@app/core/services/user-storage.service';
import { AlertService } from '@app/core/services/alert.service';
import { Router } from '@angular/router';
import { User } from '@app/core/models/user';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit, OnDestroy {
  currentUser?: User;
  isLoggedIn$!: Observable<boolean>;
  @Output() toggle: EventEmitter<boolean> = new EventEmitter();

  private _onSetCurrentUserSub!: Subscription;

  constructor(
    private authenticationService: AuthenticationService,
    private userStorageService: UserStorageService,
    private alertService: AlertService,
    private router: Router
  ) { }

  ngOnInit() {
    this.isLoggedIn$ = this.authenticationService.isLoggedIn;
    this.currentUser = this.userStorageService.currentUser;
    this._onSetCurrentUserSub = this.authenticationService.onSetCurrentUser$.subscribe(data => {
      this.currentUser = data;
    });
  }

  handleToggleMenu(event: MouseEvent) {
    event.preventDefault();
    this.toggle.emit(undefined);
  }

  handleLogOut = (event: MouseEvent) => {
    event.preventDefault();
    this.authenticationService.logOut();
    this.alertService.success('Logged out.', 'You has been successfully logged out.');
    this.router.navigate(['/auth/sign-in']);
  }

  ngOnDestroy() {
    this._onSetCurrentUserSub.unsubscribe();
  }
}
